import React, { useState } from "react";
import {Outlet, Link } from "react-router-dom";
import './Hero.css';
import './HomePage.css';
import mapIcon from '../map-icon.jpg';

const HomePage = () => {

    const [isOpen, setIsOpen] = useState(false);
    
    const toggleMobileMenu = () => {
        setIsOpen(!isOpen);
    };


    return(
        <div className="container-homepage"
           style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/1.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
                overflow: 'hidden'
            }}
        >
            <div className="navbar-homePage">
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>

                {isOpen && <div className="menu-overlay" onClick={toggleMobileMenu}></div>}

                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                    <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                    <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                </nav>

                {/* Hexagon Nav (desktop) */}
                <section className="hero--home">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon" ><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                </section>

                {/** Footer!! */}
                <div className="footer-homepage-homepage">
                    <footer className="custom-footer">
                        <div className="footer-content" >
                            <div className="footer-right" >
                            {/** <img src={logo} alt="Auto Bauer Logo" className="footer-logo" />*/}
                            <p>
                                LAM Autoservice<br />
                                Schwarzbach 152<br />
                                42277 Wuppertal<br />
                                Tel: +49 176 72987527<br />
                                <a
                                    href="https://maps.app.goo.gl/4eDnBybKuX6SYjxV9"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer-left"
                                    >
                                    <p className="footer-label">
                                        <strong>DER WEG<br />ZU UNS:</strong>
                                    </p>
                                    <img src={mapIcon} alt="Map Icon" className="map-icon" />
                                </a>
                            </p>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
            < Outlet />
            
        </div>
    );
};

export default HomePage;

/**
 * <section className="hero--home">
            <div class="hexagon-wrapper">
            <div class="hexagon" id="hexagon-über-uns">
                <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
            </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/kontakt" class="link">Kontakt</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                </div>
            </div>

            <Outlet />
        </section>
 */